import { render, staticRenderFns } from "./NoGroupOrTeamDashboard.vue?vue&type=template&id=c6070ba0&scoped=true"
import script from "./NoGroupOrTeamDashboard.vue?vue&type=script&lang=js"
export * from "./NoGroupOrTeamDashboard.vue?vue&type=script&lang=js"
import style0 from "./NoGroupOrTeamDashboard.vue?vue&type=style&index=0&id=c6070ba0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6070ba0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c6070ba0')) {
      api.createRecord('c6070ba0', component.options)
    } else {
      api.reload('c6070ba0', component.options)
    }
    module.hot.accept("./NoGroupOrTeamDashboard.vue?vue&type=template&id=c6070ba0&scoped=true", function () {
      api.rerender('c6070ba0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/NoGroupOrTeamDashboard.vue"
export default component.exports